export default __webpack_public_path__ + "static/media/ProgramJudging.fb75f880.png";